/**
 * Resolves which real office to treat as "current" when JWT office is GUEST_FOLDERS
 * (e.g. sidebar highlight, return to office folders).
 */

import { sortOfficeAffiliationsForSelectorDisplay } from "@Front/Utils/officeSelectorOrderHelpers";

export const GUEST_FOLDERS_UID = "GUEST_FOLDERS";

export type OfficeAffiliationLike = {
	office_uid?: string | null;
	uid?: string | null;
	office?: { name?: string } | null;
};

export function isGuestFoldersAffiliation(a: OfficeAffiliationLike): boolean {
	const uid = a.office_uid ?? a.uid;
	return uid === GUEST_FOLDERS_UID || (typeof uid === "string" && uid.startsWith("guest-folders-"));
}

/**
 * Prefer last real office UID stored before GUEST_FOLDERS (e.g. sessionStorage).
 * If realOffices is empty (list not loaded yet), trust lastRealBeforeGuest.
 * @returns UID to activate, or null if none
 */
export function resolvePreferredRealOfficeUid(
	lastRealBeforeGuest: string | null,
	realOffices: OfficeAffiliationLike[],
): string | null {
	const ordered = sortOfficeAffiliationsForSelectorDisplay(realOffices);
	const firstRealOfficeUid = ordered[0]?.office_uid ?? ordered[0]?.uid ?? null;
	const isValidLast =
		Boolean(lastRealBeforeGuest) &&
		lastRealBeforeGuest !== GUEST_FOLDERS_UID &&
		(realOffices.length === 0 || realOffices.some((aff) => (aff.office_uid ?? aff.uid) === lastRealBeforeGuest));
	return isValidLast ? lastRealBeforeGuest : firstRealOfficeUid;
}
